import { useAlarms } from '../../../hooks/useAlarms';
import { useAuthStore } from '../../../store/auth.store';
import { getVisibleNavSections } from './navItems';
import { SidebarBrand } from './SidebarBrand';
import { SidebarNavSection } from './SidebarNavSection';
import { SidebarUserCard } from './SidebarUserCard';
import { SidebarFooterStatus } from './SidebarFooterStatus';
import { TooltipProvider } from '../../ui/Tooltip';

export const SIDEBAR_WIDTH = 252;
/** The collapsed "thin strip" width — just enough for a centered 36px icon/avatar with padding. */
export const SIDEBAR_COLLAPSED_WIDTH = 72;

export interface SidebarProps {
  onNavigate?: () => void;
}

export function Sidebar({ onNavigate }: SidebarProps) {
  // 1. ดึงข้อมูล Alarms จาก Hook ภายใน Component
  const { data: alarms } = useAlarms();
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin');

  // 2. คำนวณจำนวน Alarms ที่ยังไม่อ่าน (Not Acknowledged)
  const unreadCount = alarms?.filter((a) => !a.acknowledged).length ?? 0;

  // 3. ส่ง unreadCount ไปดึง NavSections ที่มี badgeCount อัปเดตล่าสุด
  const visibleNavSections = getVisibleNavSections(unreadCount, isAdmin);

  return (
    <TooltipProvider>
      <div className="flex h-full flex-col py-4">
        <SidebarBrand />
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          {visibleNavSections.map((section) => (
            <SidebarNavSection key={section.label} section={section} onNavigate={onNavigate} />
          ))}
        </div>
        <SidebarUserCard />
        <SidebarFooterStatus />
      </div>
    </TooltipProvider>
  );
}